var _rect, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "Greenway Health",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 42 C 20 28, 32 18, 44 18 C 36 30, 32 38, 20 42 Z",
    fill: "#3f9c35"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 30,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1e5631"
  }, "GREENWAY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 46,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 500,
    fill: "#64748b",
    letterSpacing: 1.2
  }, "HEALTH")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenway);
export default __webpack_public_path__ + "static/media/greenway.c56f6b8ec2f1e2027f105d9f8758fcda.svg";
export { ForwardRef as ReactComponent };